export default __webpack_public_path__ + "static/cset_logo-2aabe2b6a17ab9bfb15c856d46cf325b.svg";